export { NotificationDetailsContainer } from './notification-details-container';
